import { useEffect } from 'react';
import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from '@azure/msal-browser';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { msalConfig } from '@/authConfig';

export function useMsalTokenAcquisition(
  onTokenAcquired: (token: string) => void,
) {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  useEffect(() => {
    let accountOfEnv = accounts.find(
      (acc) =>
        acc.environment ===
        new URL(process.env.NEXT_PUBLIC_B2C_BASE_URL ?? '').host,
    );
    if (inProgress !== InteractionStatus.None) return;

    if (isAuthenticated && !!accountOfEnv) {
      instance
        .acquireTokenSilent({
          account: accountOfEnv,
          scopes: msalConfig.auth.scopes,
        })
        .then((authResult) => {
          onTokenAcquired(authResult.accessToken);
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            // Fallback to redirect or popup
            instance.acquireTokenRedirect({
              scopes: msalConfig.auth.scopes,
            });
          } else {
            console.error('Token acquisition failed', error);
          }
        });
    } else {
      instance.acquireTokenRedirect({
        scopes: msalConfig.auth.scopes,
      });
    }
  }, [isAuthenticated, inProgress, accounts, instance, onTokenAcquired]);
}
